import React from 'react'

const Mask = ({ visible, toggle, children, align = "items-center", top = "", bottom = "" }) => {
    return (
        <div id="modal" className={ `${ visible ? 'scale-100' : 'scale-0' } overflow-hidden overflow-y-scroll fixed z-30 ${bottom} top-0 left-0 w-screen h-screen flex ${align} justify-center bg-gray-700 bg-opacity-50 transform transition-transform duration-300` }>
            {/* Modal content */}
            <span className="z-0 overflow-hidden absolute w-full h-full" onClick={ toggle } />
            { children }
        </div>
    )
}

export default Mask